import styled, { CSSObject } from "styled-components";
import { theme } from "../../styles/appTheme";

const inputBase: CSSObject = {
  width: "100%",
  border: `1px solid ${theme.palette.gray}`,
  borderRadius: 4,
  padding: "10px 16px",
  fontSize: 14,
  fontWeight: 500,
  color: theme.palette.text,
  "&::placeholder": {
    color: theme.palette.divider,
  },
};

const labelTextBase: CSSObject = {
  display: "block",
  fontSize: 14,
  fontWeight: 700,
  marginBottom: 12,
};

export const PanelTitle = styled.div({
  background: theme.palette.bg,
  color: theme.palette.text,
  fontSize: 18,
  fontWeight: 700,
  padding: "12px",
  marginTop: 24,
});

export const Notice = styled.section({
  border: `1px dashed ${theme.palette.main}`,
  borderRadius: 8,
  padding: "16px",
  marginTop: 24,
});

export const NoticeTitle = styled.h2({
  margin: 0,
  color: theme.palette.text,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 4,
  fontSize: 18,
  fontWeight: 700,
});

export const NoticeTitleIcon = styled.span({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 1,
  color: theme.palette.main,
});

export const NoticeBody = styled.p({
  margin: "12px 0 0",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.5,
});

export const FormGrid = styled.form({
  display: "grid",
  gap: 24,
  marginTop: 24,
});

export const FieldTitle = styled.span({
  ...labelTextBase,
  i: {
    background: theme.palette.alert,
    color: theme.palette.white,
    fontStyle: "normal",
    fontSize: 12,
    fontWeight: 700,
    borderRadius: 4,
    padding: "4px 8px",
  },
});

export const InputField = styled.input(inputBase);

export const TwoCol = styled.div({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 12,
});

export const WarnText = styled.p({
  color: theme.palette.alert,
  margin: "0 0 12px",
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.5,
});

export const HintText = styled.p({
  margin: "0 0 12px",
  color: theme.palette.gray,
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.5,
});

export const PolicyText = styled.p({
  margin: 0,
  textAlign: "center",
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.5,
});

export const PolicyLink = styled.a({
  color: theme.palette.main,
  textDecoration: "underline",
});

export const PrimaryButton = styled.button({
  border: 0,
  borderRadius: 8,
  padding: 16,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.5,
  cursor: "pointer",
  color: theme.palette.white,
  background: theme.palette.main,
  "&:disabled": {
    opacity: 0.6,
    cursor: "not-allowed",
  },
});

export const LinkButton = styled.button({
  border: 0,
  background: "transparent",
  color: theme.palette.text,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.5,
  cursor: "pointer",
});

export const ErrorText = styled.p({
  margin: 0,
  color: theme.palette.alert,
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.5,
  textAlign: "center",
});
